function mobile(state = {}, action) {
  switch (action.type) {
    case "LAYOUT_MOBILE": {
      const isMobile = {
        isMobile: action.data,
      };

      return Object.assign({}, state, isMobile);
    }
    case "TOGGLE_TAKEOVER": {
      const openTakeover = {
        openTakeover: action.data,
      };

      return Object.assign({}, state, openTakeover);
    }
    default: {
      return state;
    }
  }
}

export default mobile;



// WEBPACK FOOTER //
// ./assets/shared/reducers/mobile.js